// extracted by mini-css-extract-plugin
export default {"background":"xz9qWkA_","popupWindow":"JLb6RxPl","popupHead":"GEf4pcXY","popupName":"pj_r8oLw","popupClose":"WS3BaOTq","popupBody":"Ng1n6kUP"};